import { supabase } from '@/lib/supabase';

export const DELETE_CONFIRM_TEXT = 'VYMAZAT';

// Jediná cesta mazania účtu — používa ju Settings (DeleteAccountSection)
// aj consent modal krok „Nesúhlasím → Zmazať účet“.
// Hard-delete cez Edge Function; pri zlyhaní vyhodí chybu, odhlásenie rieši volajúci.
export async function deleteOwnAccount() {
  const { data, error } = await supabase.functions.invoke(
    'delete-user-account',
    { method: 'POST' }
  );

  if (error) {
    throw new Error(error.message || 'Vymazanie zlyhalo.');
  }

  if (!data?.success) {
    throw new Error(data?.error || 'Vymazanie zlyhalo.');
  }
}
